import { RouteRecordRaw } from 'vue-router';
import { WEB_LINKS } from '@/shared/web/type';
import { WEB_ROUTE_PATHS } from '@/shared/web/settings';

import auth from '@/app/middleware/auth';
import guest from '@/app/middleware/guest';
import firstSignRight from '@/app/middleware/firstSignRight';
import isSignRight from '@/app/middleware/isSignRight';
import twoGisAuth from '@/app/middleware/twoGisAuth';

export const routes: Array<RouteRecordRaw> = [
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.AUTH],
    name: WEB_LINKS.AUTH,
    children: [
      {
        path: WEB_ROUTE_PATHS[WEB_LINKS.LOGIN],
        name: WEB_LINKS.LOGIN,
        component: () => import('@/pages/auth'),
        meta: {
          middleware: [guest],
        },
      },
    ],
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.HOME],
    name: WEB_LINKS.HOME,
    redirect: { name: WEB_LINKS.MAIN },
    component: () => import('@/pages/home'),
    meta: {
      middleware: [auth],
    },
    children: [
      {
        path: WEB_ROUTE_PATHS[WEB_LINKS.MAIN],
        name: WEB_LINKS.MAIN,
        component: () => import('@/pages/main'),
      },
      {
        path: WEB_ROUTE_PATHS[WEB_LINKS.SETTINGS],
        name: WEB_LINKS.SETTINGS,
        component: () => import('@/pages/settings/main'),
      },
      {
        path: WEB_ROUTE_PATHS[WEB_LINKS.PAYMENT],
        name: WEB_LINKS.PAYMENT,
        component: () => import('@/pages/payment/main'),
      },
      {
        path: WEB_ROUTE_PATHS[WEB_LINKS.PRODUCTS],
        name: WEB_LINKS.PRODUCTS,
        component: () => import('@/pages/products/main'),
      },
    ],
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.INVOICE],
    name: WEB_LINKS.INVOICE,
    component: () => import('@/pages/invoice').then((module) => module.PageInvoiceMain),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.INVOICE_DETAIL],
    name: WEB_LINKS.INVOICE_DETAIL,
    component: () => import('@/pages/invoice').then((module) => module.PageInvoiceDetail),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.INVOICE_INDIVIDUAL],
    name: WEB_LINKS.INVOICE_INDIVIDUAL,
    component: () => import('@/pages/invoice').then((module) => module.PageInvoiceIndividual),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.HISTORY_PAYMENT],
    name: WEB_LINKS.HISTORY_PAYMENT,
    component: () => import('@/pages/history'),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.INVOICE],
    name: WEB_LINKS.INVOICE,
    component: () => import('@/pages/invoice').then((module) => module.PageInvoiceMain),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.OUTLET_MAIN],
    name: WEB_LINKS.OUTLET_MAIN,
    component: () => import('@/pages/outlet').then((module) => module.PageOutletMain),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.OUTLET_INVITED_CASHIERS],
    name: WEB_LINKS.OUTLET_INVITED_CASHIERS,
    component: () => import('@/pages/outlet').then((module) => module.PageOutletInvitedCashiers),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.PAYMENT_DETAIL],
    name: WEB_LINKS.PAYMENT_DETAIL,
    component: () => import('@/pages/payment/detail'),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.DOCUMENTS],
    name: WEB_LINKS.DOCUMENTS,
    component: () => import('@/pages/documents'),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.POS_TERMINAL],
    name: WEB_LINKS.POS_TERMINAL,
    component: () => import('@/pages/pos-terminal'),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.PAYMENT_FORM],
    name: WEB_LINKS.PAYMENT_FORM,
    component: () => import('@/pages/payment/form'),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.SETTINGS_ACCOUNT_VISIBILITY],
    name: WEB_LINKS.SETTINGS_ACCOUNT_VISIBILITY,
    component: () => import('@/pages/settings/account-visibility'),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.SETTINGS_EMPLOYEE_LIST],
    name: WEB_LINKS.SETTINGS_EMPLOYEE_LIST,
    component: () => import('@/pages/settings/employee/list'),
    meta: {
      middleware: [auth, firstSignRight],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.SETTINGS_EMPLOYEE_DETAIL],
    name: WEB_LINKS.SETTINGS_EMPLOYEE_DETAIL,
    component: () => import('@/pages/settings/employee/detail'),
    meta: {
      middleware: [auth, firstSignRight],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.SETTINGS_EMPLOYEE_OUTLET_ACCESS],
    name: WEB_LINKS.SETTINGS_EMPLOYEE_OUTLET_ACCESS,
    component: () => import('@/pages/settings/employee/outlet-access'),
    meta: {
      middleware: [auth, firstSignRight],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.SETTINGS_REGULATIONS],
    name: WEB_LINKS.SETTINGS_REGULATIONS,
    component: () => import('@/pages/settings/regulations'),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.SETTINGS_API_KEY],
    name: WEB_LINKS.SETTINGS_API_KEY,
    component: () => import('@/pages/settings/api-key'),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.ACCOUNT],
    name: WEB_LINKS.ACCOUNT,
    component: () => import('@/pages/account/detail'),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.INSTALLMENT],
    name: WEB_LINKS.INSTALLMENT,
    component: () => import('@/pages/products/installment').then((module) => module.PageInstallmentMain),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.INSTALLMENT_DETAIL],
    name: WEB_LINKS.INSTALLMENT_DETAIL,
    component: () => import('@/pages/products/installment').then((module) => module.PageInstallmentDetailOperation),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.INSTALLMENT_ONBOARDING],
    name: WEB_LINKS.INSTALLMENT_ONBOARDING,
    component: () => import('@/pages/products/installment').then((module) => module.PageInstallmentOnboarding),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.LOAN_CLAIMS],
    name: WEB_LINKS.LOAN_CLAIMS,
    component: () => import('@/pages/products/loan-claims/list'),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.CARD],
    name: WEB_LINKS.CARD,
    component: () => import('@/pages/card/list'),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.CARD_LIMIT],
    name: WEB_LINKS.CARD_LIMIT,
    component: () => import('@/pages/card/limit'),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.CARD_BLOCK],
    name: WEB_LINKS.CARD_BLOCK,
    component: () => import('@/pages/card/block'),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.POS_MAIN],
    name: WEB_LINKS.POS_MAIN,
    component: () => import('@/widgets/pos-terminal/WidgetPosMain.vue'),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.POS_DETAIL],
    name: WEB_LINKS.POS_DETAIL,
    component: () => import('@/pages/pos/ui/PagePosDetail.vue'),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.POS_ORDER],
    name: WEB_LINKS.POS_ORDER,
    component: () => import('@/pages/pos').then((module) => module.PagePosOrder),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.OUTLET_DETAILS],
    name: WEB_LINKS.OUTLET_DETAILS,
    component: () => import('@/pages/outlet').then((module) => module.PageOutletDetails),
    meta: {
      middleware: [auth, isSignRight],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.OUTLET_CREATE],
    name: WEB_LINKS.OUTLET_CREATE,
    component: () => import('@/pages/outlet').then((module) => module.PageOutletCreate),
    meta: {
      middleware: [auth, isSignRight],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.OUTLET_EMPLOYEE_DETAILS],
    name: WEB_LINKS.OUTLET_EMPLOYEE_DETAILS,
    component: () => import('@/pages/outlet').then((module) => module.PageOutletEmployeeDetails),
    meta: {
      middleware: [auth, isSignRight],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.OUTLET_EMPLOYEE_CREATE],
    name: WEB_LINKS.OUTLET_EMPLOYEE_CREATE,
    component: () => import('@/pages/outlet').then((module) => module.PageOutletEmployeeCreate),
    meta: {
      middleware: [auth, isSignRight],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.OUTLET_CASH_EDIT],
    name: WEB_LINKS.OUTLET_CASH_EDIT,
    component: () => import('@/pages/outlet').then((module) => module.PageOutletCashEdit),
    meta: {
      middleware: [auth, isSignRight],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.PERSONAL_QR],
    name: WEB_LINKS.PERSONAL_QR,
    component: () => import('@/pages/outlet').then((module) => module.PageOutletPersonalQr),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.TWO_GIS],
    name: WEB_LINKS.TWO_GIS,
    component: () => import('@/pages/two-gis').then((module) => module.PageTwoGis),
    meta: {
      middleware: [twoGisAuth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.BANK_OFFICES],
    name: WEB_LINKS.BANK_OFFICES,
    component: () => import('@/pages/bank-offices').then((module) => module.PageBankOfficesMap),
    meta: {
      middleware: [twoGisAuth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.EXCHANGE_RATE],
    name: WEB_LINKS.EXCHANGE_RATE,
    component: () => import('@/pages/exchange-rate-details'),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.QR_CODE],
    name: WEB_LINKS.QR_CODE,
    component: () => import('@/pages/qr').then((module) => module.PageQrCode),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.QR_PAYMENT],
    name: WEB_LINKS.QR_PAYMENT,
    component: () => import('@/pages/qr').then((module) => module.PageQrPayment),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.BUDGET],
    name: WEB_LINKS.BUDGET,
    component: () => import('@/pages/budget/main'),
    meta: {
      middleware: [isSignRight],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.BUDGET_PAYMENT_PROCESS],
    name: WEB_LINKS.BUDGET_PAYMENT_PROCESS,
    component: () => import('@/pages/budget/payment-process'),
    meta: {
      middleware: [isSignRight],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.SALARY_STATEMENT_DETAIL],
    name: WEB_LINKS.SALARY_STATEMENT_DETAIL,
    component: () => import('@/pages/products/salary/detail'),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.SALARY_STATEMENT_DETAIL_PROCESSING_FILE],
    name: WEB_LINKS.SALARY_STATEMENT_DETAIL_PROCESSING_FILE,
    component: () => import('@/pages/products/salary/detail-processing-file'),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.SALARY_MANUAL],
    name: WEB_LINKS.SALARY_MANUAL,
    component: () => import('@/pages/products/salary/manual'),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.SALARY],
    name: WEB_LINKS.SALARY,
    component: () => import('@/pages/products/salary/list'),
    meta: {
      middleware: [isSignRight],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.LETTER],
    name: WEB_LINKS.LETTER,
    component: () => import('@/pages/letter/list'),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.LETTER_CREATE],
    name: WEB_LINKS.LETTER_CREATE,
    component: () => import('@/pages/letter/create'),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.LETTER_DETAIL],
    name: WEB_LINKS.LETTER_DETAIL,
    component: () => import('@/pages/letter/details'),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.NPT],
    name: WEB_LINKS.NPT,
    component: () => import('@/pages/npt').then((module) => module.PageNpt),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.INVOICE_LEGAL],
    name: WEB_LINKS.INVOICE_LEGAL,
    component: () => import('@/pages/invoice').then((module) => module.PageInvoiceLegal),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.APPROVE],
    name: WEB_LINKS.APPROVE,
    component: () => import('@/pages/approve').then((module) => module.PageApprove),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.ACCOUNT_REQ],
    name: WEB_LINKS.ACCOUNT_REQ,
    component: () => import('@/pages/account-requisites').then((module) => module.PageRequisites),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: WEB_ROUTE_PATHS[WEB_LINKS.NOTIFICATION],
    name: WEB_LINKS.NOTIFICATION,
    component: () => import('@/pages/notification').then((module) => module.PageNotification),
    meta: {
      middleware: [auth],
    },
  },
];
